<template>
  <div class="lego-table-wrap" :style="tableStyle">
    <lego-paging-table
      ref="list"
      title
      multiSelect
      selectAll
      tableFixed
      isNotScrollX
      v-model="selectedItems"
      :noPage="true"
      :noDataText="noDataText"
      :items="items"
      :headers="viewHeaders"
      :selectActionControl="false"
      :scrollFixRow="scrollFixRow"
      :scrollMaxRow="scrollMaxRow"
      :selectMaxCnt="selectMaxItem"
      valueKey="productSq"
      :messageMaxCnt="
        $t('page.performance.monitoringTargetMaxLimite', {
          max: maxSelected,
          asg: asgVm
        })
      "
      @sort="onSort"
      @update:modelValue="onCheck"
      @inputAll="onCheck"
      :noControl="false"
    />
  </div>
</template>
<script>
import { LB, LOAD_BALANCER } from '../utils/constant';
import { scpmUtil } from '@/utils/scpmUtil.js';
import TooltipAndOther from '@/containers/components/TooltipAndOther';
import _ from 'lodash';
import { mapGetters } from 'vuex';

const DEFAULT_MODAL_STYLE = {
  width: '100%',
  height: '295px'
};
export default {
  name: 'AddMonitorTargetItem',
  components: {},
  props: {
    searchText: {
      type: String,
      default: ''
    },
    monitorInfo: {
      type: Object,
      default: () => {
        return {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: ''
        };
      }
    },
    height: {
      type: [String, Number],
      default: () => DEFAULT_MODAL_STYLE.height
    },
    width: {
      type: [String, Number],
      default: () => DEFAULT_MODAL_STYLE.width
    },
    scrollFixRow: {
      type: Number,
      default: null
    },
    scrollMaxRow: {
      type: Number,
      default: 6
    },
    selectMaxItem: {
      type: Number,
      default: 10
    },
    isSelectAsg: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('searchStore', { isResetFilterXss: 'getResetFilterXss' }),
    asgVm() {
      if (this.isSelectAsg) return `/${this.$t('searchLabel.asgVM')}`;
      return '';
    },
    maxSelected() {
      if (this.isSelectAsg) return this.$const.MAX_SELECTED;
      return this.selectMaxItem;
    },
    viewHeaders() {
      return this.headers.filter((v) => v.isShow);
    },
    tableStyle() {
      let height = this.height;
      let width = this.width;
      if (typeof this.height === 'number') height += 'px';
      if (typeof this.width === 'number') width += 'px';
      return { width, height };
    }
  },
  data() {
    return {
      productTypeCode: '',
      viewItems: [],
      selectedItems: [],
      selectedOrgItems: [],
      items: [],
      noDataText: '',
      headers: [
        {
          text: this.$t('searchLabel.monTarget'),
          value: 'productName',
          width: 200,
          sortable: true,
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.vpnGatewayName'),
          value: 'vpnGatewayName',
          width: 290,
          sortable: true,
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.version'),
          value: 'productVersion',
          width: 150,
          sortable: true,
          bodyAlign: 'left',
          isShow: false
        },
        {
          text: this.$t('header.namespaceName'),
          value: 'namespaceName',
          width: 200,
          sortable: true,
          bodyAlign: 'left',

          isShow: false
        },
        {
          text: this.$t('searchLabel.saType'),
          value: 'saType',
          width: 150,
          sortable: true,
          bodyAlign: 'left',
          isShow: false
        },
        {
          text: this.$t('searchLabel.ip'),
          value: 'ipAddress',
          width: 150,
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('header.attachmentID'),
          value: 'resourceId',
          width: 300,
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.dataOpsName'),
          value: 'managerName',
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.clusterName'),
          value: 'clusterName',
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.resourceName'),
          value: 'resourceName',
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false
        },
        {
          text: this.$t('searchLabel.tag'),
          value: 'productTags',
          sortable: true,
          bodyAlign: 'left',
          defaultValue: '-',
          isShow: false,
          customCell: {
            name: 'TagInofs',
            components: { TooltipAndOther },
            props: {
              item: {
                type: Object,
                default: () => {}
              },
              iIdx: {
                type: Number
              }
            },
            template: `
              <TooltipAndOther :id='iIdx' v-if='item.productTags.length' :items='item.productTags' onlyShowAnd/>`
          }
        }
      ]
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler(newValue) {
        this.selectedItems = [...newValue];
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.productTypeCode = this.monitorInfo.pProductTypeCode;
      this.objectTypeCode = this.monitorInfo.pObjectTypeCode;
      this.setHeaderProp();
      this.getSummaries(null, null, true);
    },
    execSearch(reset = false, textForSearch) {
      if (reset) this.$refs.list.$refs.table.resetSort();
      this.getSummaries(null, textForSearch);
    },
    getSearchText(textForSearch, isCheckSearch) {
      if (textForSearch || textForSearch === '') {
        return textForSearch;
      }

      if (isCheckSearch) {
        return '';
      }

      return this.searchText;
    },
    //모니터링 대상 목록조회
    getSummaries(param, textForSearch, isCheckSearch = false) {
      param = param || {};
      param.includeTags = 'Y';
      this.$http.product
        .getSummaries(
          {
            page: 0,
            size: 0,
            productName: this.getSearchText(textForSearch, isCheckSearch),
            ...param
          },
          this.productTypeCode,
          true
        )
        .then((data) => {
          this.items = [];

          data.forEach((item) => {
            let dataAttr = item.productInfoAttrs;
            if (dataAttr && dataAttr.length > 0) {
              dataAttr.forEach((attr) => {
                if (item[attr.attrName] === undefined) item[attr.attrName] = attr.attrValue;
              });
            }

            item.productResourceId = item.resourceId;
            const tags = item.productTags || [];
            item.productTags = tags.map((d) => scpmUtil.getTagText(d));
            item.firstProductTag = tags.length > 0 ? scpmUtil.getTagText(tags[0]) : '';
            this.items.push(item);
          });
        })
        .catch((e) => {
          this.$emit('clearSearchText');
          if (this.isResetFilterXss) {
            this.selectedItems = [];
            this.$emit('onCheck', this.selectedItems);
            this.getSummaries(null, null, true);
          }

          if (e && e.code == 'AccessDenied') {
            this.noDataText = this.$t('message.listMonitorAccessError'); // listMonitor 권한이 필요
            this.items = [];
            this.selectedItems = [];
            this.selectedOrgItems = [];
            this.$alert(e);
          }
        });
    },

    checkSelectedItem() {
      if (this.selectedItems.length || this.isSelectAsg) {
        return;
      }
      let _codes = [];
      this.monitorInfo.pProductTypeCodes.forEach((item) => {
        const findItem = this.items.find((_row) => _row.resourceId == item.resourceId);
        if (findItem) _codes.push(findItem);
      });
      this.selectedItems = _codes;
      this.onCheck(this.selectedItems);
    },
    async onCheck(selectedItems, targetMaxCheck) {
      if (targetMaxCheck) return;
      if (!selectedItems.length) return this.$emit('onCheck', selectedItems);
      const productResourceIds = selectedItems.map((v) => {
        if (v.productResourceId) return v.productResourceId;
        if (v.key) return v.key;
        return v.resourceId;
      });

      const listDataCheckAuth = selectedItems.map((v) => {
        return {
          productResourceId: v.productResourceId ? v.productResourceId : v.resourceId,
          productName: v.productName
        };
      });
      const param = {
        productTypeCode: this.productTypeCode,
        actionName: this.$const.AuthorizationAction.MONITOR_VIEW,
        productResourceIds,
        listDataCheckAuth
      };

      const data = await this.$store.dispatch('authStore/checkProductResource', param);

      if (data.type === this.$const.AuthorizationResult.ALLOW) {
        return this.$emit('onCheck', this.selectedItems);
      }
      //Function for check resource ids error, if it exits, it doesn't need to check others target
      if (!data.resourceIds || !data.resourceIds.length) return;

      const remainSelected = selectedItems.filter(
        (item) =>
          !data.resourceIds.includes(item['resourceId']) &&
          !data.resourceIds.includes(item['productName'])
      );

      this.$refs.list.selected = remainSelected;
      this.selectedItems = remainSelected;

      await this.onCheck(this.selectedItems, targetMaxCheck);

      this.$emit('onCheck', this.selectedItems);
    },
    onSort({ asc, value }) {
      const { ASC: _ASC, DESC: _DESC } = this.$const.SORT_TYPES;
      if (value === 'productTags') {
        this.items = this.$util.customSort(this.items, 'firstProductTag', asc ? _ASC : _DESC);
      } else {
        const params = {
          sort: [`${value}:${asc ? _ASC : _DESC}`]
        };
        return this.getSummaries(params);
      }
    },
    setHeaderProp() {
      let headersList = ['productName', 'productVersion', 'ipAddress', 'productTags'];
      if (
        [
          'VPC',
          'DC',
          'TGW',
          'File Storage(New)',
          'File Storage',
          'Block Storage(VM)',
          'Block Storage(BM)',
          'CDN',
          'Object Storage',
          'Container Registry'
        ].includes(this.productTypeCode)
      ) {
        headersList = ['productName', 'productTags'];
        this.headers = this.headers.map((item) => {
          if (item.value === 'productName') {
            item.width = 350;
          }
          return item;
        });
      } else if (this.productTypeCode === 'KAFKA') {
        headersList = ['productName', 'saType', 'ipAddress', 'productTags'];
      } else if (this.productTypeCode === 'Kubernetes') {
        headersList = ['productName', 'productVersion', 'productTags'];
      } else if (this.productTypeCode === 'Cloud Functions') {
        headersList = ['productName', 'resourceName', 'productTags'];
      } else if (this.productTypeCode === 'HPCCluster') {
        headersList = ['productName', 'clusterName', 'productTags'];
      } else if (['DataOps', 'DataFlow'].includes(this.productTypeCode)) {
        headersList = ['productName', 'managerName', 'productTags'];
        this.headers.find((v) => v.value === 'productName').text = this.$t('header.service');
        this.headers.find((v) => v.value === 'managerName').text =
          'DataFlow' == this.productTypeCode
            ? this.$t('searchLabel.dataFlowName')
            : this.$t('searchLabel.dataOpsName'); // Data Flow명
      } else if (this.productTypeCode === 'WAN') {
        headersList = ['productName', 'resourceId', 'productTags'];
        this.headers.find((v) => v.value === 'productName').text = this.$t('header.attachmentName');
      } else if (['DataWrangler', 'QuickQuery'].includes(this.productTypeCode)) {
        headersList = ['productName', 'namespaceName', 'productTags'];
        this.headers.find((v) => v.value === 'productName').text =
          this.$t('header.monitoringTarget');
      } else if (this.productTypeCode === 'VPN') {
        headersList = ['productName', 'vpnGatewayName', 'productTags'];
      } else if (this.productTypeCode === LB) {
        this.headers.find((v) => v.value === 'productName').text = this.$t(
          'searchLabel.loadBalancer'
        );
      } else if (this.productTypeCode === LOAD_BALANCER) {
        this.headers.find((v) => v.value === 'productName').text = this.$t(
          'searchLabel.lbServiceName'
        );
      }
      //  else if (this.productTypeCode === LB) {
      //   this.headers.find((v) => v.value === 'productName').text = this.$t(
      //     'searchLabel.loadBalancer'
      //   );
      // }else if (this.productTypeCode === LOAD_BALANCER) {
      //   this.headers.find((v) => v.value === 'productName').text = this.$t(
      //     'searchLabel.lbServiceName'
      //   );
      // }
      const listDbVersion = [
        'Redis',
        'MySQL',
        'MariaDB',
        'Vertica',
        'PostgreSQL',
        'EPAS',
        'MS-SQL',
        'Valkey'
      ].map((el) => el.toLowerCase());
      const dataAnaly = ['Opensearch', 'Elasticsearch'].map((el) => el.toLowerCase())
      const dbVersionProds = [...listDbVersion, ...dataAnaly]

      if (dbVersionProds.includes(this.productTypeCode.toLowerCase())) {
        headersList = ['productName', 'dbVersion', 'ipAddress', 'productTags'];
        const idx = this.headers.findIndex((v) => v.value === 'productVersion');
        this.headers[idx].value = 'dbVersion';
        
        if(listDbVersion.includes(this.productTypeCode.toLowerCase())){
          this.headers[idx].text = this.$t('searchLabel.dbVersion')
        }
      }

      this.headers.forEach((header) => {
        if (headersList.includes(header.value)) {
          header.isShow = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-select-search {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.lego-text-field-wrapper {
  display: inline-block;
  width: calc(100% - 210px);
}

.modal-cotent-wrap {
  max-width: 1000px;
}

.scpm-drag-wrap {
  padding-top: 20px;
}
</style>
